<script setup lang="ts">
import useEmblaCarousel from 'embla-carousel-vue'
import { onMounted, ref, useTemplateRef } from 'vue'
import CmsImage from '~/layers/cms/app/components/cms/CmsImage.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
  dataLength: number
  data: CmsCustomComponentType[]
}>()

const OPTIONS = { dragFree: true, loop: false }
const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

const isUserDragging = ref(false)

const emblaBtnPrev = useTemplateRef<HTMLElement>('emblaBtnPrev')
const emblaBtnNext = useTemplateRef<HTMLElement>('emblaBtnNext')

onMounted(() => {
  if (!emblaApi.value) return
  if (props.dataLength <= 1) return

  emblaBtnNext.value?.addEventListener('click', () => {
    emblaApi.value?.scrollNext()
  })

  emblaBtnPrev.value?.addEventListener('click', () => {
    emblaApi.value?.scrollPrev()
  })

  emblaApi.value.on('pointerDown', () => {
    isUserDragging.value = true
  })

  emblaApi.value.on('pointerUp', () => {
    isUserDragging.value = false
  })
})
</script>

<template>
  <div class="flex flex-col gap-6 sticky top-40">
    <div
      v-if="dataLength > 1"
      class="embla"
    >
      <div
        ref="emblaRef"
        class="overflow-hidden"
      >
        <div
          class="flex gap-8 select-none"
        >
          <div
            v-for="(item, index) in props.data"
            :key="JSON.stringify(item)"
            class="embla__slide basis-8/10 xl:basis-4/5 shrink-0 h-full"
          >
            <CmsImage
              :cms-data-path="[...props.cmsDataPath, index, 'image']"
              class="rounded-3xl"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="dataLength > 1"
      class="flex items-start"
    >
      <div class="flex flex-row ">
        <div
          ref="emblaBtnPrev"
          class="px-7.5 py-5 border border-r-0 border-Tekst rounded-l-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
        >
          <i class="pi pi-arrow-left text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
        </div>
        <div
          ref="emblaBtnNext"
          class="px-7.5 py-5 border border-l-0 border-Tekst rounded-r-full transition-all duration-200 group group-hover:border-Secondary cursor-pointer"
        >
          <i class="pi pi-arrow-right text-Tekst group-hover:text-Secondary text-2xl! transition-all duration-200" />
        </div>
      </div>
    </div>
    <div v-else>
      <CmsImage
        :cms-data-path="[...props.cmsDataPath, 0, 'image']"
        class="rounded-3xl"
      />
    </div>
  </div>
</template>
